var Utils = require('./Utils');

function ImportWidget(config,data) {
    var self = this;
    self.inner = function () {};
    self.fn = function () {};

    self.inner.utils = config.utils != null ? config.utils: new Utils();
    self.inner.apiClient = self.inner.utils.getApiClient(config);

    self.inner.url = {
        import: config.url.import,
        log: config.url.log
    }
    self.inner.processing = ko.observable(false);
    self.date = ko.observable();

    self.inner.log_lines = ko.observableArray([]);
    self.show_log = ko.observable(false);

    self.fn.toggleShowLog = function(){
        self.show_log(!self.show_log());
    }
    self.fn.import = function(){
        self.inner.utils.confirm("Are you sure you want to import the images from Dropbox?",function(){
            self.inner.processing(true);
            var data = {
                _token: config.token,
                'date': self.date()
            };
            self.inner.apiClient.call(self.inner.url.import,data,function(response){
                if(response.success){
                    self.fn.getLog();
                    self.show_log(true);
                    self.inner.processing(false);
                    self.inner.utils.alert('Command executed');
                    $(document).trigger('imported');
                }
                else{
                    self.inner.utils.alert(response.message,'error');
                    self.inner.processing(false);
                }
            },function(e){
                self.inner.utils.alert('Error occurred while running import command','error');
                self.inner.processing(false);
            },'POST');
        });

    }

    self.fn.getLastLogLineId = function(){
        var last = self.inner.log_lines()[self.inner.log_lines().length-1];
        console.log(last);
        if(last)
            return last.id;
    }

    self.inner.empty_responses = 0;

    self.fn.getLog = function(one_time){
        var data = {
            date: self.date(),
            last_id: self.fn.getLastLogLineId()
        }
        self.inner.apiClient.call(self.inner.url.log,data,function(response){
            if(response.success){
                var lines = response.data;

                if(response.data.length == 0)
                    self.inner.empty_responses = self.inner.empty_responses + 1;
                else
                    self.inner.empty_responses = 0;

                for(var i in lines){
                    var line = lines[i];
                    self.inner.log_lines.push({id: line.id, text:line.text});
                    $(document).trigger('log-updated');
                }
                if(one_time !== false && (self.inner.empty_responses < 5))
                    setTimeout(self.fn.getLog,5000);

            }
        },function(e){},'GET');
    }

    self.getText = ko.computed(function(){
       var lines = self.inner.log_lines();
       var html = "";
       for(var i in lines)
           html += lines[i].text+"<br>";
       return html;
    });

    self.fn.getLog();
}

module.exports = ImportWidget;
